import { overlay } from 'overlay-kit';

import type { SavedQuery } from '@/entities/query/query-types';
import { requestConfirm } from '@/shared/utils/request-confirm';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/components/shadcn/alert-dialog';

export type DeleteQueryConfirmAction = 'confirm' | 'cancel';

export function showDeleteQueryConfirm(
  query: SavedQuery,
  isTrial: boolean,
): Promise<DeleteQueryConfirmAction> {
  const isPrivateQuery = query.type === 'private';
  const queryName = query.name;

  // trial고객이 private query를 삭제하려고 할 때 삭제 불가 안내 팝업 표시
  if (isTrial && isPrivateQuery) {
    return new Promise((resolve) => {
      overlay.open(({ isOpen, close }) => (
        <AlertDialog
          open={isOpen}
          onOpenChange={(open) => {
            if (!open) {
              close();
              resolve('cancel');
            }
          }}
        >
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Upgrade to discover more</AlertDialogTitle>
              <AlertDialogDescription>
                On the free trial, you can only create one query and cannot delete or recreate it.
                Upgrade your plan to explore deeper insights.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogAction
                onClick={() => {
                  close();
                  resolve('cancel');
                }}
              >
                Confirm
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      ));
    });
  }

  return requestConfirm({
    title: 'Delete Query',
    description: `Are you sure you want to delete the query "${queryName}"? This action cannot be undone.`,
    confirmButton: {
      children: 'Delete',
      variant: 'destructive',
    },
    onConfirm: () => Promise.resolve(),
  }).then(() => 'confirm');
}
